import { Connection } from '@/types/connection';
import { PortOption } from '@/types/metadata/metadata';
import { getHighestConnectionId } from '@/util/application';
import { Box, Button, List } from '@mui/material';
import { FC } from 'react';
import CustomListItem from './CustomListItem';
import FixedListItem from './FixedListItem';

type CustomListProps = {
  id: number;
  portOption: PortOption;
  connections: Connection[];
  onArrowClick: (data: Connection[]) => void;
  updateAddConnection: (newConnection: Connection) => void;
  replaceConnection: (newConnection: Connection) => void;
  deleteConnection: (id: number) => void;
};

const CustomList: FC<CustomListProps> = (props) => {
  return (
    <List
      subheader='Custom Connections'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
    >
      {props.connections?.map((connection, index) => {
        if (props.portOption.ports?.some((p) => p.action === connection.action)) {
          return (
            <FixedListItem
              key={`connection.${index}`}
              action={connection.action}
              label={connection.label}
              data={props.connections}
              index={index}
              onArrowClick={props.onArrowClick}
              onChange={(label) => props.updateAddConnection({ ...connection, label: label })}
            />
          );
        }
        return (
          <CustomListItem
            key={`connection.${index}`}
            action={connection.action}
            label={connection.label}
            data={props.connections}
            index={index}
            onArrowClick={props.onArrowClick}
            onChange={(action, label) => props.replaceConnection({ ...connection, action: action, label: label })}
            onDelete={() => {
              props.deleteConnection(connection.id);
            }}
          />
        );
      })}
      <Box>
        <Button
          variant='contained'
          color='secondary'
          sx={{ pl: 4, pr: 4 }}
          onClick={() => {
            const newDetail: Connection = {
              dst: null,
              action: '',
              label: '',
              id: getHighestConnectionId(props.connections) + 1
            };
            props.updateAddConnection(newDetail);
          }}
        >
          New
        </Button>
      </Box>
    </List>
  );
};

export default CustomList;
